export default {"src":"/_next/static/media/emptyGraph_barsThin.0aa2803c.svg","height":70,"width":353,"blurWidth":0,"blurHeight":0};